import { makeAutoObservable, observable } from "mobx"
import { nanoid } from "nanoid"
import { JsonSchema } from "./json-schema"

class Scheme {
  
  id: string
  data: JsonSchema

  constructor(id?: string) {
    this.id = id || nanoid(4)
    this.data = {
      name: "",
      slug: null,
      blocks: {},
      chains: []
    }

    makeAutoObservable(this, {
      data: observable.ref
    })
  }

  setData(data: JsonSchema) {
    this.data = data
  }
  

}

export default Scheme